import * as homepage from './homepage'
import get from 'lodash/get'
import find from 'lodash/find'
import { createSelector } from 'reselect'

export const fetchAds = homepage.fetchAds

export const getAds = (state) => homepage.getAds(state)
export const getHeroAds = (state) => homepage.getHeroAds(state)
export const selectCheckoutAds = (state) => state.homepage.ads.checkoutAds
export const selectWalletAds = (state) =>
  get(state, 'homepage.ads.walletAds', [])
const getSlides = (state) => get(state, 'homepage.ads.popupAds.slides', [])
const getAdId = (_, id) => id

export const selectPopupAds = createSelector(
  [getSlides, getAdId],
  (slides, id) => {
    if (!id) {
      return null
    }

    return find(slides, (item) => item.id == id)
  },
)
